import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { TaskTypeService } from '../services/taskType/taskType.service';
import TaskType from '../../models/TaskType';
export interface TaskTypeState {
  taskType: any[];
  status: 'idle' | 'loading' | 'failed';
}
const initialState: TaskTypeState = {
  taskType: [],
  status: 'idle',
};

const taskTypeService = new TaskTypeService();
export const taskTypeSlice = createSlice({
  name: 'taskType',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setTask: (state, action) => {
      state.taskType = action.payload;
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder.addCase(getTaskTypes.fulfilled, (state, action) => {
      state.taskType = action.payload;
    });
  },
});

export const postTaskType = createAsyncThunk(
  'taskType',
  async (taskType: TaskType) => {
    return taskTypeService.createTaskType(taskType);
  },
);

export const getTaskTypes = createAsyncThunk('get_taskType', async () => {
  return taskTypeService.getTaskType();
});

export const updateTaskType = createAsyncThunk(
  'update_taskType',
  async (taskType: TaskType) => {
    return taskTypeService.updateTaskType(taskType);
  },
);

export const deleteTaskType = createAsyncThunk(
  'delete_taskType',
  async (taskType: TaskType) => {
    return taskTypeService.deleteTaskType(taskType);
  },
);

export const { setTask } = taskTypeSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.user.value)`
export const selectTaskType = (state: RootState) => state.taskType;

export default taskTypeSlice.reducer;
